import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

export default function AccessDenied() {
    const [logo, setLogo] = useState("/logo.png"); // default fallback
    const [error, setError] = useState("");
    const navigate = useNavigate();
    useEffect(() => {


    }, []);


    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F7EBFC] px-4">
            <div className="bg-white p-6 sm:p-10 rounded-2xl shadow-2xl max-w-lg w-full border border-[#E3BCF4]">
                <div className="text-center mb-6">
                    <img src={logo} alt="18verified" className="mx-auto max-w-[100px]" />
                    <h2 className="text-xl font-bold text-[#652F9B] mt-4">
                        ALERT
                    </h2>
                </div>

                <p className="text-center text-[#652F9B] text-sm sm:text-base mb-4">
                   This Domain does not have valid license. Visit https://www.18verified.com.
                </p>
            </div>
        </div>
    );
}
